export default {
    URL : {
        API_SERVER: "https://vcserver.csitech.com/api",
        SOCKET_SERVER: "https://vcsignalingserver.csitech.com/"
    }
}